





















import { Component, Vue, Emit, Prop } from 'nuxt-property-decorator'
import ModalWrapper from '~/components/shared/modalWrapper/ModalWrapper.vue'

@Component({
  components: {
    ModalWrapper,
  },
})
export default class VideoGalleryWrapper extends Vue {
  @Prop({ default: [] }) videos: Array<string>

  @Emit('setShowVideoGallery')
  onClose(): boolean {
    return false
  }

  get lightBoxMedia() {
    return !this.videos.length
      ? []
      : this.videos.map((video: any) => {
          return {
            // For a video that can be played in the <video> tag
            type: 'video',
            thumb: '',
            sources: [
              {
                src: video.url,
                type: video.type,
              },
            ],
            caption: '',
            width: 500, // Required
            height: 500, // Required
            autoplay: false, // Optional: Autoplay video when the lightbox opens
          }
        })
  }
}
